import React, { useState } from "react";
import { Site } from "../../interfaces";
import CustomDialog from "../CustomDialog";
import { getEntityInformation } from "../actif_arborescence/EntityInformations";

interface IArobrescenceSiteProps {
  site: Site;
}

const ArborescenceSite = ({ site }: IArobrescenceSiteProps) => {
  const [selectedEntity, setSelectedEntity] = useState(null);
  const [selectedEntityType, setSelectedEntityType] = useState<string>("");

  const [modals, setModals] = useState({
    bâtiment: false,
    niveau: false,
    espace: false,
    pièce: false,
  });

  const openModal = (modalName, entity) => {
    setModals({ ...modals, [modalName]: true });
    setSelectedEntityType(modalName);
    setSelectedEntity(entity);
  };
  const closeModal = (modalName) => {
    setModals({ ...modals, [modalName]: false });
    setSelectedEntityType("");
    setSelectedEntity(null);
  };
  return (
    <>
      {site?.batiments?.map((batiment) => (
        <>
          <div className="flex space-x-2" key={batiment.id}>
            <img src="/images/prochain.png" className="w-8 h-8" />

            <button
              type="button"
              onClick={() => openModal("bâtiment", batiment)}
              className={` bg-white flex px-3 py-1  font-semibold text-md text-black border border-gray-400  rounded-md `}
            >
              <div className="flex space-x-3">
                <img src="/images/batiments-3d.png" className="w-6 h-6" />
                <span>{batiment.nom_bâtiment} </span>
              </div>
            </button>
          </div>
          {batiment.niveaux
            ?.sort((a, b) => a.numero - b.numero)
            .map((niveau) => (
              <>
                <div className="flex space-x-2 ml-10 " key={niveau.id}>
                  <img src="/images/prochain.png" className="w-8 h-8" />

                  <button
                    type="button"
                    onClick={() => openModal("niveau", niveau)}
                    className={`flex px-3 py-1  font-semibold text-md text-black border border-gray-400  rounded-md `}
                  >
                    <div className="flex space-x-3">
                      <img src="/images/couches.png" className="w-6 h-6" />
                      <span>{niveau?.nom_niveau}</span>
                    </div>
                  </button>
                </div>
                {niveau.espaces?.map((espace) => (
                  <>
                    <div className="flex space-x-2 ml-20" key={espace.id}>
                      <img src="/images/prochain.png" className="w-8 h-8" />

                      <button
                        type="button"
                        onClick={() => openModal("espace", espace)}
                        className={` flex px-3 py-1  font-semibold text-md text-black border border-gray-400  rounded-md `}
                      >
                        <div className="flex space-x-3">
                          <img src="/images/espace.png" className="w-6 h-6" />
                          <span>{espace?.nom_espace}</span>
                        </div>
                      </button>
                    </div>
                    {espace.pieces
                      ?.sort((a, b) => a.nom_piece.localeCompare(b.nom_piece))
                      .map((piece) => (
                        <div className="flex space-x-2 ml-32" key={piece?.id}>
                          <img src="/images/prochain.png" className="w-8 h-8" />

                          <button
                            type="button"
                            onClick={() => openModal("pièce", piece)}
                            className={` flex px-3 py-1  font-semibold text-md text-black border border-gray-400  rounded-md`}
                          >
                            <div className="flex space-x-3">
                              <img
                                src="/images/piece.png"
                                className="w-6 h-6"
                              />
                              <span>{piece?.nom_piece}</span>
                            </div>
                          </button>
                        </div>
                      ))}
                  </>
                ))}
              </>
            ))}
        </>
      ))}
      {selectedEntityType && (
        <CustomDialog
          closeModalDialog={() => closeModal(selectedEntityType)}
          visible={modals[selectedEntityType]}
        >
          <div className="relative w-full h-full ">
            {getEntityInformation(selectedEntity, selectedEntityType)}
          </div>
        </CustomDialog>
      )}
    </>
  );
};

export default ArborescenceSite;
